import useInitializeNewsTipAdvancedForm from './useInitializeNewsTipAdvancedForm'

export default useInitializeNewsTipAdvancedForm
